import knowledgePagesCopy, { type KnowledgePagesCopy } from '@/i18n/ns/knowledge-pages';
import type { CompanySource } from './types';

/** Recorded sources remain addressable for provenance; only included sources are active knowledge. */
export const activeKnowledgeSources = (sources: CompanySource[]) =>
  sources.filter((source) => source.includeInKnowledge === true);

type SourceKindCopy = Pick<
  KnowledgePagesCopy,
  'sourceKindStatement' | 'sourceKindWebsite' | 'sourceKindDocument'
>;

/** The kind's label in `copy` (English when a caller passes none) and its icon. */
export const sourcePresentation = (
  kind: CompanySource['kind'],
  copy: SourceKindCopy = knowledgePagesCopy.en,
) => {
  if (kind === 'company_statement')
    return { label: copy.sourceKindStatement, icon: 'knowledge' as const };
  if (kind === 'website') return { label: copy.sourceKindWebsite, icon: 'globe' as const };
  return { label: copy.sourceKindDocument, icon: 'file' as const };
};
